// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2Wg-0","buttons":"PendingPaymentAlert_buttons__1aGUI"};